import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Store } from '@/shared/store';
import { getVaultsAction } from '@/shared/store/vaults/actions';

export const useFetchVaults = () => {
    const dispatch = useDispatch();
    const { vaults, vaultsLoading, wallet } = useSelector((state: Store) => ({
        vaults: state.vaults.vaults,
        vaultsLoading: state.vaults.vaultsLoading,
        wallet: state.wallets.active.address,
    }));

    const prevWalletRef = useRef<string | null>(null);
    const hasDispatchedRef = useRef<boolean>(false);

    const isShouldFetchVaults = useMemo(() => {
        const prevWallet = prevWalletRef.current;

        const walletChanged = prevWallet !== wallet;

        const isFetchNeeded = !vaultsLoading && (vaults.length === 0 || vaults[0].address === '');

        if (isFetchNeeded || walletChanged) {
            hasDispatchedRef.current = false;
            return true;
        }

        return false;
    }, [wallet]);

    const fetchVaults = useCallback(() => {
        dispatch(
            getVaultsAction({
                withoutCache: true,
            }),
        );
    }, []);

    useEffect(() => {
        if (isShouldFetchVaults && !hasDispatchedRef.current) {
            fetchVaults();
            hasDispatchedRef.current = true;
        }

        prevWalletRef.current = wallet;
    }, [wallet, isShouldFetchVaults]);

    return {
        vaults,
        fetchVaults,
        loading: vaultsLoading,
    };
};
